import styled from 'styled-components';

/**
 * A styled component that creates a fading effect from left to right.
 * The content gradually becomes transparent on the right side.
 * Used for content that might overflow and needs to fade out gracefully.
 */
export const FadingContent = styled.div`
  position: relative;
  z-index: 0;
  mask-image: linear-gradient(to right, black 50%, transparent 100%);
  -webkit-mask-image: linear-gradient(to right, black 50%, transparent 100%);
`;

/**
 * A container positioned at the top-right of its parent.
 * Used to overlay additional content (like icons or badges) on top of the main pill content.
 * The padding-left creates space between the overlay and the main content.
 */
export const OverlayContentContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding-left: 8px;
`;
